import { useState } from 'react';
import '../styles.scss';
import { Tabs, Pagination } from 'antd';

import { SettingOutlined, EyeOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { TabsProps } from 'antd/lib';
import SupportHistoryDetail from './SupportHistoryDetail';
import MegaTable from '../../../components/MagaTableV2';
import { formatNumber } from '../../../services/mixin';
import { useNavigate } from 'react-router-dom';
import ModalAddSupportHistory from './ModalAddSupportHistory';

export default function SupportHistory({ stData = {} as any, stChange = (data: any) => { } }) {

  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState<boolean>(false)

  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.complaint_history?.list.map((col: any) => {
      if (col.field === 'contact_name') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          cellRenderer: (params: any) => {
            return (
              <div className={params.data.contact_name_id !== 'Không xác định' && params.data.contact_name_id ? 'cus-link-detail' : ''}>
                <a className="color-bage d-none" href={`/customer/pooling-data/customer-list/detail?id_sync=${params.data.contact_name_id}`}>{params.data.contact_name}</a>
                <span className="text">{params.data.contact_name || 'Không xác định'}</span>
              </div>
            )
          },
        });
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span className='custom-page-css font-light text-lg'>Chi tiết</span>,
      children: <SupportHistoryDetail stData={stData} stChange={(data) => stChange({ ...stData, ...data })} />,
    },
  ];

  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheSupportHistory',
    col: [
      {
        headerName: 'Hành động',
        field: 'action',
        width: 100,
        resizable: false,
        sortable: false,
        filter: false,
        lockPosition: 'left',
        cellRenderer: (params: any) => {
          if (Object.prototype.hasOwnProperty.call(params.data || {}, 'has_brand_permission') && params.data.has_brand_permission !== true) {
            return null;
          }
          return (
            <div className='d-flex gap-4 justify-start align-center  h-full'>
              <EyeOutlined
                className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer}`}
                onClick={() => {
                  stChange({ hotrokhieunai_show: params.data })
                  setRowActive(params?.node?.rowIndex);
                }}
              />
            </div>
          )
        },
      },
      ...tableColumns(stData.sourceColumnWarehouse),
      // { headerName: 'Ngày', field: 'doc_date' },
      // { headerName: 'Đơn vị', field: 'branch_name' },
      // { headerName: 'Điểm bán hàng', field: 'route_name' },
      // { headerName: 'Loại tương tác', field: 'complaint_type' },
      // { headerName: 'Tên xe', field: 'vehicle_name' },
      // { headerName: 'Kênh tiếp nhận', field: 'chanel_fb_name' },
      // { headerName: 'Người liên hệ', field: 'customer_name' },
      // { headerName: 'Kết quả sau xử lý', field: 'vehicle_name' },
      // { headerName: 'Ngày kết thúc', field: 'doc_date_end_proc' },
    ],
    listData: [],
    selectedRowKeys: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    height: '400px',
  });
  const [rowActive, setRowActive] = useState<number>(-1);
  return (
    <>
      <ModalAddSupportHistory
        isOpen={openModal}
        closeModal={() => setOpenModal(false)}

      />
      <div className="setting-tb-has-tab custom-page-css absolute  -top-10 right-0">
        <div className=' custom-page-css w-full flex items-center gap-3'>
          <div className='custom-page-css px-2 py-1 rounded border cursor-pointer ' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>

          <div className="custom-page-css px-2 py-1 rounded border cursor-pointer z-50"
            onClick={() => setOpenModal(true)}
          >
            <PlusCircleOutlined />
          </div>
        </div>
      </div>
      <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 pt-3">
        <div className={` w-full`}>
          <MegaTable
            stData={{ ...megaTableData, listData: stData.customers_complaints, rowActive, loading: stData.customers_complaints_loading }}
            stChange={(data) => {
              setMegaTableData((prev: any) => ({ ...prev, ...data }));
            }}
          />
          <div className={`t-table-block t-table-customer c-table-scoll-x`}>
            <div className="pagination-block">
              <Pagination
                className='rs-pagination'
                showSizeChanger
                total={stData.customers_complaints_total}
                defaultPageSize={stData.customers_complaints_params_limit}
                current={stData.customers_complaints_params_page}
                pageSizeOptions={['10', '20', '50', '100']}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={() => `Tổng cộng ${Math.ceil(stData.customers_complaints_total / stData.customers_complaints_params_limit) === 0 ? 1 : Math.ceil(stData.customers_complaints_total / stData.customers_complaints_params_page)} trang`}
                locale={{ items_per_page: 'trang' }}
                onChange={(page, pageSize) => {
                  stChange({
                    customers_complaints_params_page: page,
                    customers_complaints_params_limit: pageSize,
                    customers_complaints_loading: true,
                  })
                }}
              />
            </div>
          </div>
        </div>
        <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3">
          <Tabs defaultActiveKey="1" items={items} className='w-full' />
        </div>
      </div>
    </>
  )
}
